// assets/section-product.js

// Initialize Product Gallery (perf-friendly)
document.addEventListener('DOMContentLoaded', function () {
  // Helper: schedule a task after first paint (rAF) and when idle
  const afterFirstPaintAndIdle = (fn) => {
    const run = () => {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(fn, { timeout: 1500 });
      } else {
        // Fallback: small timeout so we yield the main thread
        setTimeout(fn, 0);
      }
    };
    // Ensure we let the first frame paint
    requestAnimationFrame(run);
  };

  // Helper: wait for the first (LCP) image in the featured gallery to be decode-ready
  const waitForLcpImage = async () => {
    const lcpImg = document.querySelector(
      '.product-gallery__featured .swiper-wrapper .swiper-slide:first-child img'
    );
    if (lcpImg && lcpImg.decode) {
      try { await lcpImg.decode(); } catch (e) { /* ignore */ }
    }
  };

  afterFirstPaintAndIdle(async () => {
    // Dynamically import Swiper *after* first paint/idle to avoid blocking LCP
    const { default: Swiper } = await import('https://unpkg.com/swiper@8/swiper-bundle.esm.browser.min.js');

    // Optional: small promise that resolves after the LCP image is decoded (or quickly if no decode())
    await waitForLcpImage();

    // Create instances with init:false so we can batch layout work
    const swiperThumbs = new Swiper('.product-gallery__thumbs', {
      init: false,
      direction: 'vertical',
      slidesPerView: 4,
      spaceBetween: 16,
      threshold: 50,
      // Avoid extra layout reads on init:
      watchOverflow: true,
      // These two cause frequent layout reads; omit unless you specifically need them:
      // watchSlidesProgress: true,
      // watchSlidesVisibility: true,
      updateOnWindowResize: false, // we'll handle resize with a debounced update below
      mousewheel: { forceToAxis: true },
      navigation: {
        nextEl: '.product-gallery__thumbs-pagination--next',
        prevEl: '.product-gallery__thumbs-pagination--prev'
      }
    });

    const swiperFeatured = new Swiper('.product-gallery__featured', {
      init: false,
      direction: 'horizontal',
      zoom: true,
      slideClass: 'swiper-slide',
      threshold: 50,
      // Let thumbs module handle syncing; no custom event wiring needed:
      thumbs: { swiper: swiperThumbs },
      pagination: {
        el: '.product-gallery__pagination',
        type: 'bullets'
      },
      updateOnWindowResize: false // debounced below
    });

    // Batch init to minimize interleaved reads/writes (reduces forced reflow)
    swiperThumbs.init();
    swiperFeatured.init();

    // Debounced resize handler to avoid repeated layout trashing
    let resizeTimer = null;
    const debouncedUpdate = () => {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (swiperThumbs && !swiperThumbs.destroyed) swiperThumbs.update();
        if (swiperFeatured && !swiperFeatured.destroyed) swiperFeatured.update();
      }, 150);
    };
    window.addEventListener('resize', debouncedUpdate, { passive: true });

    // Optional: slide-to-clicked-slide can be enabled to improve UX without manual sync handlers
    // (Thumbs module already ties selected thumb to featured slider)
    // swiperThumbs.params.slideToClickedSlide = true;
  });
});